import React from 'react'
import Price, { PriceProps } from 'shared/library/atoms/Price'
import { Basket_Response } from 'shared/presenters/graphqlTypes'
import useTranslation from 'next-translate/useTranslation'
import Flex from 'shared/library/atoms/Flex'
import { determineIsNotNullish } from 'shared/helpers/utilityTypes'
import Divider from 'shared/library/atoms/Divider'
import { Text } from 'library/atoms/Typography'

export interface EnthusiastFeeInterface extends Pick<PriceProps, 'currency'> {
  pence?: Basket_Response['enthusiast_fee_pence']
}

/**
 * Extraction as this logic was being repeated in multiple places
 *
 * We return null in cases where we do not pass a valid price into the component - this is useful in the cases where
 * we do not want to display anything at all i.e. when there is no price because the basket is empty.
 */
const EnthusiastFee = ({ pence, currency }: EnthusiastFeeInterface) => {
  const { t } = useTranslation('basket')

  if (!(determineIsNotNullish(pence) && pence > 0)) return null

  const FEE_SETTINGS = {
    pence,
    'aria-label': t('booking-fee'),
    currency
  }

  return (
    <>
      <Divider variant="solid" />
      <Flex alignItems="center" justifyContent="space-between" mt={1} width={1}>
        <Text color="secondary">{t('booking-fee')}</Text>
        <Price color="secondary" {...FEE_SETTINGS} />
      </Flex>
    </>
  )
}
export default EnthusiastFee
